import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';

const state = {
    /* Registro de bancos */
    bancos: [],
    /* Opciones de filtro y paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    nombre: '',
    incluirInactivos: false,
    
    bancosList: [],
    bancosSelectList: []
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.bancos = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.nombre = '';
        state.incluirInactivos = false;
    },

    'INICIALIZAR'(state) {
        state.bancos = [];
    },
    'SET_BANCOS'(state, bancos) {
        state.bancos = bancos;
    },
    'PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_LIST'(state) {
        state.bancosList = [];
        state.bancosSelectList = [];
    },
    'SET_LIST'(state, params) {
        state.bancosList = params.bancosList;
        state.bancosSelectList = params.bancosSelectList;
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },

    getBancos: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR')

            var queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;

            if (state.nombre != '') {
                queryString += '&nombre=' + state.nombre;
            }
            if (state.incluirInactivos) {
                if (state.incluirInactivos == true || state.incluirInactivos == 'true') {
                    queryString += '&incluirInactivos= true';
                }
            }

            apiAxios.get('bancos' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('PAGINATION', params);
                    }
                    commit('SET_BANCOS', res.data)

                    resolve();
                })
                .catch(error => {
                    resolve();
                })
            }, error => {
                reject(error);
            })
    },
    getBancosList: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            apiAxios.get('bancos/list')
                .then(res => {
                    let list = [];
                    for(let key in res.data) {
                        const item = res.data[key]
                        list.push(item.nombre.trim())
                    }
                    let params = {
                        bancosList: res.data,
                        bancosSelectList: list
                    }
                    commit('SET_LIST', params);
                    resolve();
                })
                .catch(error => {
                    /*
                    console.log(error);
                    resolve();
                    */
                    reject(error);
                })
            }, error => {
                reject(error);
            })
    },
};

const getters = {
    getField,

    bancosList (state) {
        return state.bancosList;
    },
    bancosSelectList (state) {
        return state.bancosSelectList;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}